import { graphqlOperation } from 'aws-amplify'
import { getCognitoData, makeGraphqlRequest } from '../utils'

//const OPERATIONS_GRAPHQL_URL = 'http://localhost:4001/operations/graphql'
const OPERATIONS_GRAPHQL_URL = `${window.ENV.HTTP_URL}/operations/graphql`

export async function makeOperationsApiCall({
  query,
  mutation,
  params = {},
  queryKey = null,
  resultKey = null
}) {
  const { id, idToken } = await getCognitoData()
  const operation = graphqlOperation(query || mutation, params)

  const { data, error } = await makeGraphqlRequest(
    OPERATIONS_GRAPHQL_URL,
    operation,
    idToken,
    id
  )
  if (queryKey && resultKey) {
    return { [resultKey]: data?.[queryKey], error }
  }
  return { data, error }
}
